import { render, staticRenderFns } from "./VoucherCategories.vue?vue&type=template&id=5f4502d2"
import script from "./VoucherCategories.js?vue&type=script&lang=js&external"
export * from "./VoucherCategories.js?vue&type=script&lang=js&external"
import style0 from "./VoucherCategories.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports